import { ResizeObserverBoxOptions as r } from "./ghl-ui.es1656.js";
import { calculateBoxSize as o } from "./ghl-ui.es1221.js";
import { isSVG as s, isReplacedElement as n } from "./ghl-ui.es1552.js";
var l = function(e) {
  return !s(e) && !n(e) && getComputedStyle(e).display === "inline";
}, S = function() {
  function e(i, t) {
    this.target = i, this.observedBox = t || r.CONTENT_BOX, this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }
  return e.prototype.isActive = function() {
    var i = o(this.target, this.observedBox, !0);
    return l(this.target) && (this.lastReportedSize = i), this.lastReportedSize.inlineSize !== i.inlineSize || this.lastReportedSize.blockSize !== i.blockSize;
  }, e;
}();
export {
  S as ResizeObservation
};
